import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getImage'
})
export class GetImagePipe implements PipeTransform {

  transform(images: any, ...args: any[]): unknown {
    if (images && images[args[0]] && images[args[0]][args[1]]) {
      return images[args[0]][args[1]];
    } else {
      if (args[0] == "posters") {
        return "assets/images/placeholders/placeholder_v.png";
      } else {
        return "assets/images/placeholders/placeholder_h.png";
      }
    }
  }
}
